<template>
  <div
    v-if="!getIsSidebarHidden"
    ref="sidebar"
    :class="['sidebar', { 'hovered': hovered }]"
    @mouseover="onSidebarHover(true)"
    @mouseleave="onSidebarHover(false)"
  >
    <b-list-group>
      <b-list-group-item
        :style="!hovered ? { 'border-bottom': '1px solid lightgrey' } : {}"
        class="logo"
      >
        <router-link
          to="/"
          class="logo-link"
        >
          <img
            v-if="!hovered"
            src="@/assets/images/nota-updated.png"
            width="34px"
            height="28.2px"
            alt="Logo"
            class="image1"
          >
          <img
            v-else
            src="@/assets/images/notaFull-updated.png"
            width="130px"
            height="37px"
            alt="Full Logo"
            class="image2"
          >
        </router-link>
      </b-list-group-item>

      <b-list-group-item
        v-for="item in filteredMenuItems"
        :key="item.title"
        button
      >
        <div
          v-if="item.children"
          class="sidebar-link collapsible"
          :class="{
            'active-item': isActiveMenuItem(item)
          }"
          @click="toggleCollapse(item.title)"
        >
          <img
            :src="item.icon"
            width="30px"
            alt="icon"
          >
          <p>{{ $t(item.title) }}</p>
          <b-icon
            class="iconCollapse"
            :icon="collapsed[item.title] ? 'chevron-down' : 'chevron-right'"
          />
        </div>

        <router-link
          v-else-if="item.path"
          :to="item.path"
          class="sidebar-link"
          :class="{
            'active-item': isActiveMenuItem(item)
          }"
          @click.native="clickLink"
        >
          <img
            :src="item.icon"
            width="30px"
            alt="icon"
          >
          <p>{{ $t(item.title) }}</p>
        </router-link>

        <div
          v-else
          class="sidebar-link"
          :class="{
            'active-item': isActiveMenuItem(item)
          }"
          @click="callMethod(item.method)"
        >
          <img
            :src="item.icon"
            width="30px"
            alt="icon"
          >
          <p>{{ $t(item.title) }}</p>
        </div>

        <b-collapse
          :id="item.title"
          v-model="collapsed[item.title]"
          class="submenu"
        >
          <b-list-group-item
            v-for="sub in getFilteredChildren(item)"
            :key="sub.title"
            class="submenu-item"
            :class="{
              'active-item': isActiveMenuItem(sub)
            }"
            @click.stop="clickLink"
          >
            <router-link
              :to="sub.path"
              class="sidebar-link"
            >
              <p>{{ $t(sub.title) }}</p>
            </router-link>
          </b-list-group-item>
        </b-collapse>
      </b-list-group-item>
      <CreateOrderModalSidebar @closeSidebar="closeSidebars" />
      <CreateOrderModalGenerally @closeSidebar="closeSidebars" />
    </b-list-group>
    <div
      v-b-modal.modal-personal-info
      class="sidebar-link"
      style="border-top:1px solid lightgrey;"
      @click="openPersonalInfo"
    >
      <img
        src="@/assets/images/settings.svg"
        width="30px"
        alt="test"
      >
      <p>{{ $t("Settings") }}</p>
      <Personal @closeSidebar="closeSidebars" />

    </div>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import { BIcon } from 'bootstrap-vue';
import CreateOrderModalSidebar from '@/modals/CreateOrderModalSidebar.vue';
import Personal from '@/components/personalInfo.vue'
import CreateOrderModalGenerally from '@/modals/CreateOrderModalGenerally.vue';
import menuItems from './MenuItems'

export default {
  components: {
    BIcon,
    CreateOrderModalSidebar,
    Personal,
    CreateOrderModalGenerally,
  },
  data() {
    return {
      width: 0,
      isModalOpen: false,
      collapsed: {},
      hovered: false,
      currentRoutePath: this.$route.path,
    };
  },
  computed: {
    ...mapGetters(['getLoggedInUser', 'getIsSidebarHidden']),
    filteredMenuItems() {
      return menuItems.filter((item) => { return item.roles.includes(this.getLoggedInUser?.role) });
    },
    getFilteredChildren() {
      return (item) => {
        if (!item.children) return [];
        return item.children.filter((sub) => {
          return sub.roles ? sub.roles.includes(this.getLoggedInUser?.role) : true;
        });
      };
    },
  },
  watch: {
    $route(newRoute) {
      this.currentRoutePath = newRoute.path;
    },
    width(value) {
      if (value <= 1190) {
        if (this.isModalOpen) {
          return;
        }
        this.changeVisibilityOfSidebar(true);
      } else {
        this.changeVisibilityOfSidebar(false);
      }
    },
  },
  created() {
    this.addEventListeners();
  },
  beforeUnmount() {
    this.removeEventListeners();
  },
  methods: {
    ...mapActions([
      'changeVisibilityOfSidebar',
      'resetSellableProductsSidebar',
      'resetloadCreatedOreders',
      'resetmaterialOrdersOverview',
      'resetloadMerchandisePagination',
      'accountDetails',
      'productSizes',
      'loadAllStoresByDropdown',
      'resetDetailsOrderId',
      'resetTotalStockGroupedByLocationSidebar',
    ]),
    openPersonalInfo() {
      this.isModalOpen = true;
    },
    callMethod(methodName) {
      if (typeof this[methodName] === 'function') {
        this[methodName]();
      } else {
        console.error(`Method ${methodName} is not defined`);
      }
    },
    addEventListeners() {
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('click', this.handleClickOutside);
      this.handleResize();
    },
    removeEventListeners() {
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('click', this.handleClickOutside);
    },
    isActiveMenuItem(item) {
      if (item.path && this.currentRoutePath === item.path) {
        return true;
      }

      if (item.children) {
        return item.children.some((child) => { return this.currentRoutePath === child.path });
      }

      return false;
    },
    closeSidebars() {
      this.isModalOpen = false;
    },
    handleClickOutside(event) {
      if (window.innerWidth <= 1190) {
        if (this.isModalOpen) {
          return;
        }

        if (this.$refs.sidebar && !this.$refs.sidebar.contains(event.target)) {
          this.changeVisibilityOfSidebar(true);
          Object.keys(this.collapsed).forEach((key) => {
            this.$set(this.collapsed, key, false);
          });
        }
      }
    },
    handleResize() {
      this.width = window.innerWidth;
    },
    toggleCollapse(title) {
      this.$set(this.collapsed, title, !this.collapsed[title]);
    },
    clickLink() {
      this.isModalOpen = false;
      if (this.width <= 1190) {
        this.changeVisibilityOfSidebar(true);
      }
      this.resetTabs();
    },
    resetTabs() {
      this.resetDetailsOrderId()
      this.resetTotalStockGroupedByLocationSidebar()
      // this.resetSellableProductsSidebar();
      // this.resetloadCreatedOreders();
      // this.resetmaterialOrdersOverview();
      // this.resetloadMerchandisePagination();
    },
    callNewMethodsOrder() {
      this.isModalOpen = true;
      this.accountDetails({ isActive: true })
      this.productSizes()
      this.loadAllStoresByDropdown({
        amountOfRecords: 100,
      })
      this.$bvModal.show('create-order-modal-generally');
    },
    callMethodsOrder() {
      this.isModalOpen = true;
      this.accountDetails({ isActive: true })
      this.productSizes()
      this.loadAllStoresByDropdown({
        amountOfRecords: 100,
      })
      this.$bvModal.show('add-custom-order-sidebar');
    },
    onSidebarHover(state) {
      if (this.width >= 1190) {
        this.hovered = state;
      }
      if (!state && this.width >= 1190) {
        Object.keys(this.collapsed).forEach((key) => {
          this.$set(this.collapsed, key, false);
        });
      }
    },
  },
};
</script>

<style scoped>
p {
  color: #242f6e;
}
</style>
